// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__13RZ4","divider_inner_text":"divider_divider_inner_text__2oDwb"};